import { Directive, ElementRef, OnInit } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';

@Directive({
  selector: '[bcscdigiuiCdkOverlay]'
})
export class CdkOverlayDirective implements OnInit  {

  constructor(
    private elementReference: ElementRef, 
    private cdkOverlayContainer: OverlayContainer
    ) {
      this.elementReference  = elementReference;
      this.cdkOverlayContainer = cdkOverlayContainer;
      console.log(111);
      
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.cdkOverlayContainer['myCreateContainer'](this.elementReference.nativeElement);
  }

  ngOnInit(): void {
      console.log('init');
      
  }

}
